import { inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { SeoService } from 'src/app/Shared/_services/seo/seo.service';
export interface SEOData {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  canonical?: string;
  robots?: string;
}

export const seoResolverResolver: ResolveFn<void> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const seoService = inject(SeoService);

  const { title, description, imageUrl } = route.data;

  if (title && description) {
    seoService.setSeo(title, description, imageUrl || '');
  }

  return;
};
